<tabs [tabsConfig]="tabsConfig" *ngIf="!noData && !loading"></tabs>
<router-outlet *ngIf="isAudit && !loading"></router-outlet>
<dynamic-container
    *ngIf="!noData && !loading && !isAudit"
    [prospectFields]="stageData.fields"
    [stageSchema]="stageSchema"
    [formGroup]="formGroup"
    [prospectDataId]="prospectId"
    [viewedBy]="viewedBy"
    [schemaType]="schemaType"
    [adminMode]="adminMode"
></dynamic-container>
<no-data
    *ngIf="noData"
    class="container-fluid page-container"
    titleText="No document is required."
></no-data>
<div *ngIf="loading">
    <lsq-circle-loader></lsq-circle-loader>
</div>
